import Router from 'next/router';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

const CompetenciesAdd = () => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async (values) => {
    const response = await api.post('/admin/competencies', values);
    dispatch(
      actions.addNotice({
        type: 'success',
        text: messages.competenciesAddSuccess
      })
    );
    Router.push(`/users/competencies/${response.data.competency.id}?new=true`);
  };

  const validateTitle = async (value: string) => {
    if (!value?.trim()) return messages.commonTitleEmpty;

    try {
      await api.head(`/admin/competencies?name=${value}`);
      return messages.commonTitleInUse;
    } catch (err) {
      return undefined;
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="plus"
      buttonSize="header"
      buttonText={messages.competenciesAdd}
      initialValues={{}}
      modalActionText={messages.commonAdd}
      modalTitle={messages.competenciesAdd}
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <FormGroup label={messages.commonTitle}>
          <Text
            customValidateAsync={validateTitle}
            field="name"
            id="create-competency-name"
            required={true}
            validateOnBlur={true}
            validateOnChange={true}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CompetenciesAdd;
